import moment from 'moment';

class CreateCustomerModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'CreateCustomerModal';
    $scope.customerName = '';
    $scope.customerShortName = '';
    $scope.customerAddress = '';
    $scope.companyPhone = '';
    $scope.companyFax = '';
    $scope.website = '';

    let self = this;
    $scope.addCustomer = function () {
      // Validate required fields
      if (!$scope.customerName || !$scope.customerName.trim() || 
          !$scope.customerShortName || !$scope.customerShortName.trim() ||
          !$scope.customerAddress || !$scope.customerAddress.trim()) {
        return;
      }

      const customerData = {
        name: $scope.customerName.trim(),
        shortName: $scope.customerShortName.toUpperCase().trim(),
        customerAddress: $scope.customerAddress.trim(),
        companyPhone: $scope.companyPhone ? $scope.companyPhone.trim() : null,
        companyFax: $scope.companyFax ? $scope.companyFax.trim() : null,
        website: $scope.website ? $scope.website.trim() : null
      };
      $uibModalInstance.success(customerData);
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    }

  }
}

export default CreateCustomerModalController;




// WEBPACK FOOTER //
// ./client/pages/admin/customers/modals/createCustomerModal/createCustomerModal.controller.js